import { capitalizeFirstLetter } from 'utils'

import * as Styled from './styled'

interface IProps {
  activeGenreName: string
  thumbnail: string
}

export const GenreThumbnail: React.FC<IProps> = ({
  thumbnail,
  activeGenreName
}) => {
  return (
    <Styled.GenreThumbnailWrapper>
      <Styled.GenreThumbnail src={thumbnail} />
      <Styled.GenreThumbnailLabel type="h4" color={'white'}>
        {capitalizeFirstLetter(activeGenreName)}
      </Styled.GenreThumbnailLabel>
    </Styled.GenreThumbnailWrapper>
  )
}
